<script>
import Sidebar from "@/components/Sidebar/Sidebar";
import Splash from "@/components/Splash/Splash";

export default {
  components: {Sidebar, Splash},
};
</script>

<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">
    <sidebar></sidebar>

    <div class="card-panel-main">
      <div class="card card-body card-panel-box border-0">
        <p class="title">تعریف ضرایب تعدیل</p>
        <hr/>
        <br/>

        <div class="row">
          <div class="col-6">
            <div class="card p-4">
              <p class="card-title">ضرایب تعدیل مواد</p>
              <br/>
              <router-link
                  class="btn btn-submit-1 btn-info w-50 mx-auto"
                  to="/Financial_management_and_productivity/define-adjustment-coefficients/material"
              >
                تکمیل اطلاعات / بروزرسانی
              </router-link>
            </div>
          </div>

          <div class="col-6">
            <div class="card p-4">
              <p class="card-title">ضرایب تعدیل محصولات</p>
              <br/>
              <router-link
                  class="btn btn-submit-1 btn-info w-50 mx-auto"
                  to="/Financial_management_and_productivity/define-adjustment-coefficients/products"
              >
                تکمیل اطلاعات / بروزرسانی
              </router-link>
            </div>
          </div>
        </div>

        <br/>

        <div class="row justify-content-center">
          <div class="col-6">
            <div class="card p-4">
              <p class="card-title">ضرایب تعدیل انرژی</p>
              <br/>
              <router-link
                  class="btn btn-submit-1 btn-info w-50 mx-auto"
                  to="/Financial_management_and_productivity/define-adjustment-coefficients/energy"
              >
                تکمیل اطلاعات / بروزرسانی
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.card-panel-main {
  position: absolute;
  right: 28vw;
  width: 51vw;
  height: auto;
}

.card-panel-box {
  margin: 1vw 0.9vw;
}

.title {
  font-size: 1.5vw;
}

.card-title {
  font-weight: bold;
  font-size: 1.2vw;
  text-align: center;
}
</style>
